import { Injectable } from '@angular/core';
import { AppConfigService, constants, LocalStorageService } from '@edassist/common';
import { ContentService } from '@edassist/api';
import { map, retry } from 'rxjs/operators';
import { Observable, of, catchError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WelcomePageGuard {
	constructor(private readonly contentService: ContentService) {}

	canActivate(): Observable<boolean> {
		return this.contentService.getLoginContent({ textOnly: true }).pipe(
			retry(3),
			map((content) => {
				const welcomePageEnabled = AppConfigService.isNewLandingPageEnabled(content.clientLoginDetails.clientId);
				if (!welcomePageEnabled) {
					return false;
				}

				const clientLogo = content.generalContentList.find(
					(item) => item.name === constants.contentConstants.CONTENT_NAMES.WEB_LOGO
				)?.filePath;

				const existingData = LocalStorageService.getItem(constants.localStorageKeys.CLIENT_DETAILS) || {};
				LocalStorageService.setItem(constants.localStorageKeys.CLIENT_DETAILS, {
					...existingData,
					...content.clientLoginDetails,
					id: content.clientLoginDetails.clientId,
					name: content.clientLoginDetails.clientName,
					clientLogo: clientLogo,
					clientFeaturesReferences: content.clientLoginDetails.clientFeaturesReferences,
					isCareerPathwaysEnabled: content.clientLoginDetails.careerPathwaysEnabled
				});

				return true;
			}),
			catchError(() => of(false))
		);
	}
}
